export default [
  {
    path: "esim-purchases",
    name: "esimPurchases",
    component: () =>
      import(
        /* webpackChunkName: "purchases" */ "../pages/purchases/EsimListView.vue"
      ),
    meta: {
      title: "eSIM purchases",
    },
  },
  {
    path: "local-number-purchases",
    name: "localNumberPurchases",
    component: () =>
      import(
        /* webpackChunkName: "purchases" */ "../pages/purchases/LocalNumberListView.vue"
      ),
    meta: {
      title: "Local number purchases",
    },
  },
  {
    path: "wallet-topups",
    name: "walletTopups",
    component: () =>
      import(
        /* webpackChunkName: "purchases" */ "../pages/purchases/WalletTopupListView.vue"
      ),
    meta: {
      title: "Wallet top-ups",
    },
  },
];
